// client/components/ui/ResponsivePageContainer.jsx
import React from "react";
import { twMerge } from "tailwind-merge";
import {
  mobileOverflowGuardClassName,
  mobilePagePaddingClassName,
} from "../../design/tokens.js";

const MAX_WIDTH_CLASS = {
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  "7xl": "max-w-7xl",
  full: "max-w-full",
};

/**
 * ResponsivePageContainer — einheitlicher Seiten-Innenrahmen.
 * Mobile: engere px, Overflow-Guard. Ab md: gleiche Abstände wie bisherige Seiten (px-4 py-6).
 */
export default function ResponsivePageContainer({
  children,
  className = "",
  maxWidth = "6xl",
  as: Tag = "div",
}) {
  const maxW = MAX_WIDTH_CLASS[maxWidth] || MAX_WIDTH_CLASS["6xl"];

  return (
    <Tag
      className={twMerge(
        "mx-auto w-full min-w-0",
        maxW,
        mobilePagePaddingClassName,
        mobileOverflowGuardClassName,
        className,
      )}
    >
      {children}
    </Tag>
  );
}
